var isPlainObject = {};
export {
  isPlainObject as __exports
};
//# sourceMappingURL=isPlainObject.js.map
